export default "__VITE_ASSET__QW4F9_IOrmUMcXpR7YZvSw__"